import * as React from "react";
import styles from "./contactform.module.scss";

export interface LookupFormProps {
  onLookup: (orderNumber: number, email: string) => void;
}

/**
 * Allows a customer to lookup an order
 * @param props
 * @returns
 */
export const LookupForm: React.FC<LookupFormProps> = (props) => {
  const [email, setEmail] = React.useState("");
  const [orderNumberValue, setOrderNumberValue] = React.useState("");

  const [formError, setError] = React.useState("");

  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();

    setError("");

    const orderNumber = parseInt(orderNumberValue, 10);

    if (isNaN(orderNumber)) {
      setError("Invalid Order Number");
      return;
    }
    if (email.length === 0) {
      //todo: validate email address
      setError("Invalid Email Address");
      return;
    }

    if (orderNumber > 0) {
      props.onLookup(orderNumber, email);
    }
  };
  return (
    <div className={styles.lookupForm}>      
      <div className="order-number">
        <label htmlFor="OrderNumber">
          Order Number
          <span className="small">
            (as shown on confirmation page or email)
          </span>
        </label>
        <input
          className="form-control"
          placeholder="Order Number"
          name="OrderNumber"
          value={orderNumberValue}
          onChange={(e) => setOrderNumberValue(e.target.value)}
        ></input>
      </div>
      <div className="email-address">
        <label htmlFor="Email">
          Billing Email Address
          <span className="small">(must match email used for order)</span>
        </label>
        <input
          type="text"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="form-control"
          name="Email"
          placeholder="Billing Email Address"
        ></input>
      </div>
      <button onClick={handleClick} className={styles.lookupButton}>
        Lookup Order
      </button>
      {formError && <div className={styles.error}>{formError}</div>}
    </div>
  );
};
